// extracted by mini-css-extract-plugin
export default {"scrollbar-wrapper":"toWGxm","scrollbarWrapper":"toWGxm"};